import { useEffect, useState } from 'react'

const { DEBUG, KEYCLOAK: { CLIENT_ID } } = window.conf
const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

const getArea = (component) => {
    switch (component) {
        case 0: return 'Home'
        case 1: return 'Live'
        case 2: return 'Archive'
        case 3: return 'Timelapse'
        default: return ''
    }
}

// Loads the etracker analytics script and keeps the `et_pagename`/`et_areas` params in sync with the current top-level component
export const useStatistics = (component) => {

    const [isStatisticsLoaded, setIsStatisticsLoaded] = useState(false)

    const handleLoad = () => setIsStatisticsLoaded(true)
    const handleError = (error) => console.error('[etracker] Failed to initialize:', error)

    useEffect(() => {
        if (isDevelopment) {
            DEBUG && console.log('[etracker] Development mode active - skipping initialization')
            return
        }

        const existingScript = document.getElementById('_etLoader')

        if (existingScript) {
            DEBUG && console.log('[etracker] Script already loaded - skipping initialization')
            setIsStatisticsLoaded(true)
            return
        }

        const script = document.createElement('script')
        const params = document.createElement('script')
        let areaTextNode = document.createTextNode(`var et_pagename = "${CLIENT_ID}";`)

        if (component) {
            const area = getArea(component)
            areaTextNode = document.createTextNode(`var et_pagename = "${CLIENT_ID}"; var et_areas = "${area}";`)
        }

        script.setAttribute('id', '_etLoader')
        script.setAttribute('type', 'text/javascript')
        script.setAttribute('charset', 'UTF-8')
        script.setAttribute('data-block-cookies', 'true')
        script.setAttribute('data-respect-dnt', 'true')
        script.setAttribute('data-secure-code', 'g9g1km')
        script.setAttribute('src', '//code.etracker.com/code/e.js')
        script.setAttribute('async', '')

        params.setAttribute('id', '_etParams')
        params.setAttribute('type', 'text/javascript')
        params.appendChild(areaTextNode)

        document.head.appendChild(params)
        document.head.appendChild(script)

        script.addEventListener('load', handleLoad)
        script.addEventListener('error', handleError)

        return () => {
            script.removeEventListener('load', handleLoad)
            script.removeEventListener('error', handleError)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isDevelopment) return

        const existingParams = document.getElementById('_etParams')

        if (existingParams && component !== undefined) {
            const area = getArea(component)
            existingParams.textContent = `var et_pagename = "${CLIENT_ID}"; var et_areas = "${area}";`
        }
    }, [component])

    return isStatisticsLoaded
}
